import { c as _c } from "react/compiler-runtime";
import type { FeedbackTipo } from '../types/negociacaoFeedbackTypes';
const PATHS: Record<FeedbackTipo, {
  cuff: string;
  body: string;
}> = {
  positive: {
    cuff: 'M5.83333 8.33333V18.3333',
    body: 'M12.5 4.9L11.6667 8.33333H16.525C16.7837 8.33333 17.0389 8.39358 17.2704 8.50929C17.5018 8.625 17.7031 8.79301 17.8583 9C18.0136 9.20699 18.1185 9.44729 18.1648 9.70186C18.2111 9.95643 18.1974 10.2183 18.125 10.4667L16.1833 17.1333C16.0824 17.4795 15.8718 17.7836 15.5833 18C15.2948 18.2164 14.944 18.3333 14.5833 18.3333H3.33333C2.89131 18.3333 2.46738 18.1577 2.15482 17.8452C1.84226 17.5326 1.66667 17.1087 1.66667 16.6667V10C1.66667 9.55797 1.84226 9.13405 2.15482 8.82149C2.46738 8.50893 2.89131 8.33333 3.33333 8.33333H5.63333C5.9434 8.33317 6.24728 8.24651 6.5108 8.0831C6.77431 7.91969 6.98702 7.68601 7.125 7.40833L10 1.66667C10.393 1.67153 10.7798 1.76514 11.1315 1.9405C11.4832 2.11585 11.7908 2.36842 12.0312 2.67934C12.2716 2.99025 12.4386 3.35147 12.5198 3.736C12.601 4.12054 12.5942 4.51845 12.5 4.9Z'
  },
  negative: {
    cuff: 'M14.1667 11.6667V1.66667',
    body: 'M7.5 15.1L8.33333 11.6667H3.475C3.21626 11.6667 2.96107 11.6064 2.72964 11.4907C2.49822 11.375 2.29691 11.207 2.14167 11C1.98642 10.793 1.8815 10.5527 1.83522 10.2981C1.78893 10.0436 1.80255 9.78173 1.875 9.53333L3.81667 2.86667C3.91764 2.52047 4.12817 2.21637 4.41667 2C4.70516 1.78363 5.05605 1.66667 5.41667 1.66667H16.6667C17.1087 1.66667 17.5326 1.84226 17.8452 2.15482C18.1577 2.46738 18.3333 2.89131 18.3333 3.33333V10C18.3333 10.442 18.1577 10.866 17.8452 11.1785C17.5326 11.4911 17.1087 11.6667 16.6667 11.6667H14.3667C14.0566 11.6668 13.7527 11.7535 13.4892 11.9169C13.2257 12.0803 13.013 12.314 12.875 12.5917L10 18.3333C9.60702 18.3285 9.22022 18.2349 8.8685 18.0595C8.51677 17.8841 8.20923 17.6316 7.96883 17.3207C7.72843 17.0098 7.5614 16.6485 7.48022 16.264C7.39904 15.8795 7.4058 15.4816 7.5 15.1Z'
  }
};
interface ThumbIconProps {
  tipo: FeedbackTipo;
  filled?: boolean;
  className?: string;
}
export function ThumbIcon(t0) {
  const $ = _c(10);
  const {
    tipo,
    filled: t1,
    className
  } = t0;
  const filled = t1 === undefined ? false : t1;
  const {
    cuff,
    body
  } = PATHS[tipo];
  const fill = filled ? "currentColor" : "none";
  let t2;
  if ($[0] !== cuff || $[1] !== fill) {
    t2 = <path d={cuff} fill={fill} stroke="currentColor" strokeWidth={1.66667} strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = cuff;
    $[1] = fill;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== body || $[4] !== fill) {
    t3 = <path d={body} fill={fill} stroke="currentColor" strokeWidth={1.66667} strokeLinecap="round" strokeLinejoin="round" />;
    $[3] = body;
    $[4] = fill;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== className || $[7] !== t2 || $[8] !== t3) {
    t4 = <svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">{t2}{t3}</svg>;
    $[6] = className;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}